import { isFileType } from '@savgroup-front-common/core/helpers/AdditionalInformations/isFileType';
import { AdditionalInformationDto } from '@savgroup-front-common/types';

import { buildFileUploadEndpoints } from '../helpers/buildFileUploadEndpoints';

export const adaptFileTypeNeededInformation = ({
  fileId,
}: {
  fileId?: string;
}) => {
  return (
    acc: (AdditionalInformationDto & {
      claimIds?: string[];
      internalId: string;
      fileUploadEndpoints?: {
        uploadEndpoint: string;
        deleteEndpoint: string;
      };
    })[],
    neededInformation: AdditionalInformationDto & {
      claimIds?: string[];
      internalId: string;
    },
  ) => {
    const { id, claimIds } = neededInformation;

    const adaptedNeededInformation = isFileType(neededInformation)
      ? {
          ...neededInformation,
          fileUploadEndpoints: buildFileUploadEndpoints({
            fileId,
            claimIds,
            id,
          }),
        }
      : neededInformation;

    return [...acc, adaptedNeededInformation];
  };
};
